import React, { useRef, useState } from 'react';
import { UploadCloud } from 'lucide-react';

export default function UploadInforme({ onArchivo, cargando, error, tipo }) {
  const fileInputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      onArchivo(e.dataTransfer.files[0]);
    }
  };

  const handleChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      onArchivo(e.target.files[0]);
    }
  };

  return (
    <div className="w-full">
      <div
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        onClick={() => fileInputRef.current?.click()}
        className={`border-2 border-dashed rounded-2xl p-8 text-center cursor-pointer transition-colors ${
          isDragging ? 'border-blue-500 bg-blue-50' : 'border-gray-300 hover:border-blue-400 hover:bg-gray-50'
        }`}
      >
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleChange}
          className="hidden"
          accept=".xlsx,.xls,.csv,.pdf,.docx"
        />
        
        {cargando ? (
          <div className="flex flex-col items-center gap-2">
            <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
            <p className="text-sm font-bold text-gray-700">Procesando archivo...</p>
          </div>
        ) : (
          <div className="flex flex-col items-center gap-2">
            <UploadCloud className="w-10 h-10 text-blue-500" />
            <p className="text-sm font-bold text-gray-700">
              Arrastra tu archivo aquí o haz clic para buscar
            </p>
            <p className="text-xs text-gray-500">
              Formatos soportados: Excel, CSV, PDF, Word
            </p>
          </div>
        )}
      </div>
      
      {error && (
        <div className="mt-2 text-sm text-red-600 font-bold text-center">
          {error}
        </div>
      )}
      
      {tipo && (
        <div className="mt-2 text-xs text-gray-500 text-center">
          Último archivo procesado: {tipo.toUpperCase()}
        </div>
      )}
    </div>
  );
}